import React, { useState } from "react";
import { WeightAnswerFormat } from "../../../../types/Survey";
import "./WeightQuestion.css"
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import "text-security/text-security.css"
import SurveyInput from "../../Components/SurveyInput/SurveyInput";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let answerFormat = props.answerFormat as WeightAnswerFormat;
    let currentResult = props.result as QuestionResultModel;

    let weight = currentResult.Answer ? parseFloat(currentResult.Answer) : undefined;
    if (answerFormat.measurementSystem == "USC") {
        weight = weight ? (weight * 2.20462) : undefined;
    }
    let [weightAnswer, setWeightAnswer] = useState<string>(weight ? parseFloat(weight.toFixed(1)).toString() : "");

    function answerChanged(answer: string) {
        if (answer != "" && !matchesInputFormat(answer)) {
            return;
        }

        setWeightAnswer(answer);

        let weightAnswer = parseFloat(answer);
        if (answerFormat.measurementSystem == "USC" && !isNaN(weightAnswer)) {
            weightAnswer = weightAnswer * 0.453592;
        }

        props.onResultChange({ ...props.result, Answer: weightAnswer ? parseFloat(weightAnswer.toFixed(1)).toString() : "" } as QuestionResultModel);
    }

    function matchesInputFormat(value: string) {
        return /^[0-9]*\.?[0-9]*$/.test(value);
    }

    return <SurveyFormItem
        className="weight-question"
        topBorder
        bottomBorder
        label={props.label}
        labelFor={props.inputIdForLabel}
        labelPosition={props.labelPosition}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <div className="weight-question-inputs">
            <SurveyInput id={props.inputIdForLabel}
                className="weight-question-input"
                value={weightAnswer}
                type="text"
                placeholder={answerFormat.measurementSystem == "USC" ? "lb" : "kg"}
                onChange={(e) => answerChanged(e.target.value)}
                onEnterPressed={props.onEnterPressed}
                inputMode="decimal"
                variant={props.variant}
            />
            <span className="weight-question-inline-label">{answerFormat.measurementSystem == "USC" ? "lb" : "kg"}</span>
        </div>
    </SurveyFormItem >
}